module.exports = __webpack_public_path__ + "d21eb4836cc7e2fd0324b4928e2254c5.webp";